import { axiosRequest } from '@src/helpers';
import {ENV} from "@environments/environment";
const {AWS_S3_FILE_UPLOAD, API_URL} = ENV

export const fbVerify = async (data: any) => {
  return await axiosRequest(`${API_URL}/get-b2c-product-info`, {
    method: 'POST',
    body: JSON.stringify(data)
  });
};
